import React from "react";
import logo from "../logo/kusy-logo.webp"; // lub "./logo/kusy-logo.webp" jeśli plik jest obok

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-black flex flex-col items-center justify-center z-[9999]">
      <img
        src={logo}
        alt="Loading logo"
        className="h-24 w-auto mb-6"
      />
      <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
